class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    // No data-url means the markup was rendered directly; nothing to fetch.
    if (!this.dataset.url) return;

    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      this.loadFrom(this.dataset.url, true);
    };

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }

  // Fetch a rendered section, drop the current product, and render the slider.
  // `allowFallback` lets the metafield-filtered request fall back to the default
  // recommendation engine when it yields no usable products.
  loadFrom(url, allowFallback) {
    fetch(url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('product-recommendations');
        if (!recommendations) return;

        // Remove the current product before the slider initialises so the
        // filtered "same effetto" collection never lists the product itself.
        const currentId = this.dataset.currentProductId;
        if (currentId) {
          const self = recommendations.querySelector(`.swiper-slide[data-product-id="${currentId}"]`);
          if (self) self.remove();
        }

        const hasProducts = recommendations.querySelectorAll('.swiper-slide').length > 0;
        if (!hasProducts) {
          if (allowFallback && this.dataset.fallbackUrl) {
            this.loadFrom(this.dataset.fallbackUrl, false);
          } else {
            this.remove();
          }
          return;
        }

        this.innerHTML = recommendations.innerHTML;
        if (typeof skAnimation === 'function') {
          setTimeout(() => skAnimation(), 300);
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }
}

customElements.define('product-recommendations', ProductRecommendations);
